import { render, staticRenderFns } from "./orderNumChart.vue?vue&type=template&id=651a87b8"
import script from "./orderNumChart.vue?vue&type=script&lang=js"
export * from "./orderNumChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports